// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"style_inputWrapper__159d4","inputSingleColumnWrapper":"style_inputSingleColumnWrapper__3FuPG","inputDoubleColumnWrapper":"style_inputDoubleColumnWrapper__F7h7C"};